import { useLanguage } from '@/contexts/LanguageContext';
import { Home, Scale } from 'lucide-react';

export default function VerifiedBadge({ role, size = 'sm', showLabel = false }) {
  const { language } = useLanguage();
  const tt = (en, es) => language === 'es' ? es : en;

  const isAgent = role === 'agent';
  const Icon = isAgent ? Home : Scale;
  const label = isAgent ? tt('Verified Agent', 'Agente Verificado') : tt('Verified Lawyer', 'Abogado Verificado');

  const sizeMap = {
    xs: { icon: 'w-3 h-3', wrapper: 'w-4 h-4', text: 'text-[9px]' },
    sm: { icon: 'w-3.5 h-3.5', wrapper: 'w-5 h-5', text: 'text-[10px]' },
    md: { icon: 'w-4 h-4', wrapper: 'w-6 h-6', text: 'text-xs' },
  };
  const s = sizeMap[size] || sizeMap.sm;

  return (
    <span className="inline-flex items-center gap-1" data-testid="verified-badge" title={label}>
      <span className={`${s.wrapper} rounded-full bg-green-500 flex items-center justify-center flex-shrink-0`}>
        <Icon className={`${s.icon} text-white`} strokeWidth={2.5} />
      </span>
      {showLabel && <span className={`${s.text} font-semibold text-green-700`}>{label}</span>}
    </span>
  );
}
